export const serialize = <T>(data: T) => {
  return JSON.stringify(data);
};

export const deserialize = <T = unknown>(data: string): T => JSON.parse(data);
